import { LayoutDashboard, Globe, ClipboardList, ListTodo, Receipt, Megaphone, ShieldCheck, Network } from 'lucide-react';
import type { ComponentType } from 'react';

export type NavItem = {
  to: string;
  label: string;
  shortLabel?: string;
  icon: ComponentType<{ className?: string }>;
};

export const navItems: NavItem[] = [
  { to: '/', label: "Vue d'ensemble", shortLabel: 'Overview', icon: LayoutDashboard },
  { to: '/sites', label: 'Sites', icon: Globe },
  { to: '/maintenance', label: 'Maintenance WP', shortLabel: 'Maint.', icon: ShieldCheck },
  { to: '/campaigns', label: 'Campagnes', icon: Megaphone },
  { to: '/projects', label: 'Projets', icon: ClipboardList },
  { to: '/actions', label: 'Actions', icon: ListTodo },
  { to: '/pipeline', label: 'Pipeline', icon: Receipt },
  { to: '/network', label: 'Réseau', icon: Network },
];
